import React, { Component, Fragment } from 'react'
import Input from '@material-ui/core/Input'
import InputLabel from '@material-ui/core/InputLabel'
import FormControl from '@material-ui/core/FormControl'
import { withStyles } from '@material-ui/core/styles'
import { connect } from 'react-redux'
import { contentActions, messageActions } from '../../../actions'
import TextField from '@material-ui/core/TextField'
import SelectWrapped from '../../../components/SelectWrapped'
import { formatContentSelectValue, filterOptionsFunction } from '../../../utils'
import Typography from '@material-ui/core/Typography'
import * as API from '../../../api'
import Button from '@material-ui/core/Button'
import FileUpload from 'material-ui/svg-icons/file/file-upload'
import { readOnly } from '../../../utils/permissions'
import EditIcon from 'material-ui/svg-icons/image/edit'
import EditDocumentModal from '../EditDocumentModal'

import {
  IsbnField,
  CodigoCapituloField,
  EdicaoField,
  CopyrightField
} from '../../../components/Fields'

const styles = theme => ({
  layout: {
    height: 'calc(100% - 64px)',
    position: 'relative'
  },
  contentForm: {
    background: '#fff',
    height: '100%',
    boxSizing: 'border-box',
    padding: theme.spacing.unit * 3,
    overflow: 'auto'
  },
  formGroup: {
    padding: '12px 0'
  },
  formControl: {
    margin: '12px 0'
  },
  uploadButton: {
    margin: '15px 0',
    padding: '0 16px',
    background: 'rgb(0, 45, 114)',
    color: '#fff'
  },
  uploadButtonIcon: {
    color: 'inherit !important',
    marginLeft: '3px'
  },
  editButton: {
    margin: '15px 0',
    marginLeft: '10px',
    padding: '0 16px',
    background: 'rgb(0, 45, 114)',
    color: '#fff'
  },
  uploadButtonIcon: {
    color: 'inherit !important',
    marginLeft: '3px'
  }
})

class Aula extends Component {
  handleChangeFile = e => {
    e.preventDefault()
    const { handleChangeContent, content, getHtmlPreview, changeMessage } = this.props

    let [file] = e.target.files

    if (file) {
      handleChangeContent({
        ...content,
        document: file || ''
      })
      getHtmlPreview({ document: file })
        .then(response => {
          changeMessage({ message: 'Pré-visualização carregada com sucesso.' })
        })
        .catch(error => {
          const { response = {} } = error
          const { status } = response
          if (status === 400) {
            changeMessage({ message: 'Formato de arquivo inválido.' })
          }
        })
    } else {
      handleChangeContent({
        ...content,
        document: file || ''
      })
    }
  }
  componentDidMount() {
    this.props.removeHtmlDocument()
  }
  render() {
    const {
      classes,
      content,
      handleChangeContent,
      handleChangeReference,
      contentFormErrors,
      formTouched,
      removeHtmlDocument,
      token,
      openEditDocumentModal
    } = this.props

    const { handleChangeFile } = this

    const isReadOnly = readOnly(content.tipo, token)

    return (
      <Fragment>
        <div>
          <input type="file" id="upload" style={{ display: 'none' }} onChange={handleChangeFile} />
          {!!content.document && (
            <Button
              small
              onClick={() => {
                removeHtmlDocument()
              }}
              color={'secondary'}
              disabled={isReadOnly}
            >
              Remover
            </Button>
          )}
          <Button
            htmlFor="upload"
            component={'label'}
            variant="raised"
            color={'primary'}
            className={classes.uploadButton}
            disabled={isReadOnly}
          >
            Upload HTML <FileUpload className={classes.uploadButtonIcon} />
          </Button>
          <Button
            onClick={() => openEditDocumentModal()}
            component={'label'}
            variant="raised"
            color={'primary'}
            className={classes.editButton}
            disabled={isReadOnly}
          >
            Editar <EditIcon className={classes.uploadButtonIcon} />
          </Button>
          {!((contentFormErrors.fields || {})['document'] || {}).valid && formTouched ? (
            <Typography className={classes.errorMessage} noWrap color={'error'}>
              {((contentFormErrors.fields || {})['document'] || {}).errorMessage}
            </Typography>
          ) : null}
        </div>
        <FormControl
          error={!((contentFormErrors.fields || {})['titulo'] || {}).valid && formTouched}
          className={classes.formControl}
          fullWidth
        >
          <InputLabel htmlFor="field-titulo">Título</InputLabel>
          <Input
            disabled={isReadOnly}
            fullWidth
            required={'required'}
            type="text"
            onChange={e => {
              handleChangeContent({ ...content, titulo: e.target.value })
            }}
            value={content.titulo}
            id="field-titulo"
          />
          {!((contentFormErrors.fields || {})['titulo'] || {}).valid && formTouched ? (
            <Typography className={classes.errorMessage} noWrap color={'error'}>
              {((contentFormErrors.fields || {})['titulo'] || {}).errorMessage}
            </Typography>
          ) : null}
        </FormControl>
        <div className={classes.formControl}>
          <TextField
            disabled={isReadOnly}
            fullWidth
            onChange={obj => {
              handleChangeContent({ ...content, autores: obj })
            }}
            error={!((contentFormErrors.fields || {})['autores'] || {}).valid && formTouched}
            value={formatContentSelectValue(content.autores || [])}
            placeholder="Selecione..."
            name="react-select-chip-autores"
            label="Autores"
            InputLabelProps={{
              shrink: true
            }}
            InputProps={{
              inputComponent: SelectWrapped,
              inputProps: {
                multi: true,
                filterOptions: filterOptionsFunction,
                instanceId: 'react-select-chip-label',
                id: 'react-select-chip-autores',
                loadOptions: API.authors.getSelectAuthors,
                disableDelete: isReadOnly
              }
            }}
          />
          {!((contentFormErrors.fields || {})['autores'] || {}).valid && formTouched ? (
            <Typography className={classes.errorMessage} noWrap color={'error'}>
              {((contentFormErrors.fields || {})['autores'] || {}).errorMessage}
            </Typography>
          ) : null}
        </div>
        <FormControl
          error={!((contentFormErrors.fields || {})['codigo'] || {}).valid && formTouched}
          className={classes.formControl}
          fullWidth
        >
          <InputLabel htmlFor="field-codigo">Código</InputLabel>
          <Input
            disabled={isReadOnly}
            fullWidth
            required={'required'}
            type="text"
            inputComponent={CodigoCapituloField}
            onChange={e => {
              handleChangeContent({ ...content, codigo: e.target.value })
            }}
            value={content.codigo || ''}
            id="field-codigo"
          />
          {!((contentFormErrors.fields || {})['codigo'] || {}).valid && formTouched ? (
            <Typography className={classes.errorMessage} noWrap color={'error'}>
              {((contentFormErrors.fields || {})['codigo'] || {}).errorMessage}
            </Typography>
          ) : null}
        </FormControl>
        <div className={classes.formControl}>
          <TextField
            disabled={isReadOnly}
            fullWidth
            onChange={obj => {
              handleChangeContent({ ...content, especialidades: obj })
            }}
            error={!((contentFormErrors.fields || {})['especialidades'] || {}).valid && formTouched}
            value={formatContentSelectValue(content.especialidades || [])}
            placeholder="Selecione..."
            name="react-select-chip-especialidades"
            label="Especialidades"
            InputLabelProps={{
              shrink: true
            }}
            InputProps={{
              inputComponent: SelectWrapped,
              inputProps: {
                multi: true,
                filterOptions: filterOptionsFunction,
                instanceId: 'react-select-chip-label',
                id: 'react-select-chip-especialidades',
                loadOptions: API.specialities.getSelectSpecialities,
                disableDelete: isReadOnly
              }
            }}
          />
          {!((contentFormErrors.fields || {})['especialidades'] || {}).valid && formTouched ? (
            <Typography className={classes.errorMessage} noWrap color={'error'}>
              {((contentFormErrors.fields || {})['especialidades'] || {}).errorMessage}
            </Typography>
          ) : null}
        </div>
        <div className={classes.formControl}>
          <TextField
            disabled={isReadOnly}
            fullWidth
            onChange={obj => {
              handleChangeContent({ ...content, palavrasChave: obj })
            }}
            error={!((contentFormErrors.fields || {})['palavrasChave'] || {}).valid && formTouched}
            value={formatContentSelectValue(content.palavrasChave || [])}
            placeholder="Selecione..."
            name="react-select-chip-keywords"
            label="Palavras-chave"
            InputLabelProps={{
              shrink: true
            }}
            InputProps={{
              inputComponent: SelectWrapped,
              inputProps: {
                multi: true,
                filterOptions: filterOptionsFunction,
                instanceId: 'react-select-chip-label',
                id: 'react-select-chip-keywords',
                loadOptions: API.keywords.getSelectKeywords,
                disableDelete: isReadOnly
              }
            }}
          />
          {!((contentFormErrors.fields || {})['palavrasChave'] || {}).valid && formTouched ? (
            <Typography className={classes.errorMessage} noWrap color={'error'}>
              {((contentFormErrors.fields || {})['palavrasChave'] || {}).errorMessage}
            </Typography>
          ) : null}
        </div>
        <FormControl
          error={!((contentFormErrors.fields || {})['pesoDA'] || {}).valid && formTouched}
          className={classes.formControl}
          fullWidth
        >
          <InputLabel htmlFor="field-pesoDA">Peso DA</InputLabel>
          <Input
            disabled={isReadOnly}
            fullWidth
            required={'required'}
            type="number"
            onChange={e => {
              handleChangeContent({ ...content, pesoDA: e.target.value })
            }}
            value={content.pesoDA}
            id="field-pesoDA"
          />
          {!((contentFormErrors.fields || {})['pesoDA'] || {}).valid && formTouched ? (
            <Typography className={classes.errorMessage} noWrap color={'error'}>
              {((contentFormErrors.fields || {})['pesoDA'] || {}).errorMessage}
            </Typography>
          ) : null}
        </FormControl>

        <FormControl
          error={!((contentFormErrors.fields || {})['idioma'] || {}).valid && formTouched}
          className={classes.formControl}
          fullWidth
        >
          <InputLabel htmlFor="field-idioma">Idioma</InputLabel>
          <Input
            disabled={isReadOnly}
            fullWidth
            required={'required'}
            type="text"
            onChange={e => {
              handleChangeContent({ ...content, idioma: e.target.value })
            }}
            value={content.idioma}
            id="field-idioma"
          />
          {!((contentFormErrors.fields || {})['idioma'] || {}).valid && formTouched ? (
            <Typography className={classes.errorMessage} noWrap color={'error'}>
              {((contentFormErrors.fields || {})['idioma'] || {}).errorMessage}
            </Typography>
          ) : null}
        </FormControl>
        <fieldset>
          <legend>Livro</legend>
          <div className={classes.formControl}>
            <TextField
              disabled={isReadOnly}
              fullWidth
              className={classes.formControl}
              onChange={livroReferencia => {
                handleChangeReference('livro', livroReferencia)
              }}
              error={
                !((contentFormErrors.fields || {})['livroReferencia'] || {}).valid && formTouched
              }
              value={content.livroReferencia}
              placeholder="Selecione..."
              name="react-select-chip-preCadastro"
              label="Pré-cadastro"
              InputLabelProps={{
                shrink: true
              }}
              InputProps={{
                inputComponent: SelectWrapped,
                inputProps: {
                  multi: false,
                  filterOptions: filterOptionsFunction,
                  instanceId: 'react-select-chip-label',
                  id: 'react-select-chip-preCadastro',
                  options: [],
                  loadOptions: API.preRegistrations.getSelectPreRegistrations('livro')
                }
              }}
            />
            {!((contentFormErrors.fields || {})['livroReferencia'] || {}).valid && formTouched ? (
              <Typography className={classes.errorMessage} noWrap color={'error'}>
                {((contentFormErrors.fields || {})['livroReferencia'] || {}).errorMessage}
              </Typography>
            ) : null}
          </div>
          <FormControl
            error={!((contentFormErrors.fields || {})['tituloLivro'] || {}).valid && formTouched}
            className={classes.formControl}
            fullWidth
          >
            <InputLabel htmlFor="field-tituloLivro">Título livro</InputLabel>
            <Input
              disabled={!!content.livroReferencia || isReadOnly}
              fullWidth
              required={'required'}
              type="text"
              onChange={e => {
                handleChangeContent({ ...content, tituloLivro: e.target.value })
              }}
              value={content.tituloLivro}
              id="field-tituloLivro"
            />
            {!((contentFormErrors.fields || {})['tituloLivro'] || {}).valid && formTouched ? (
              <Typography className={classes.errorMessage} noWrap color={'error'}>
                {((contentFormErrors.fields || {})['tituloLivro'] || {}).errorMessage}
              </Typography>
            ) : null}
          </FormControl>
          <div className={classes.formControl}>
            <TextField
              disabled={!!content.livroReferencia || isReadOnly}
              fullWidth
              onChange={obj => {
                handleChangeContent({ ...content, autoresLivro: obj })
              }}
              error={!((contentFormErrors.fields || {})['autoresLivro'] || {}).valid && formTouched}
              value={formatContentSelectValue(content.autoresLivro || [])}
              placeholder="Selecione..."
              name="react-select-chip-autoresLivro"
              label="Autores livro"
              InputLabelProps={{
                shrink: true
              }}
              InputProps={{
                inputComponent: SelectWrapped,
                inputProps: {
                  multi: true,
                  filterOptions: filterOptionsFunction,
                  instanceId: 'react-select-chip-label',
                  id: 'react-select-chip-autoresLivro',
                  loadOptions: API.authors.getSelectAuthors,
                  disableDelete: !!content.livroReferencia || isReadOnly
                }
              }}
            />
            {!((contentFormErrors.fields || {})['autoresLivro'] || {}).valid && formTouched ? (
              <Typography className={classes.errorMessage} noWrap color={'error'}>
                {((contentFormErrors.fields || {})['autoresLivro'] || {}).errorMessage}
              </Typography>
            ) : null}
          </div>
          <FormControl
            error={!((contentFormErrors.fields || {})['isbn'] || {}).valid && formTouched}
            className={classes.formControl}
            fullWidth
          >
            <InputLabel htmlFor="field-isbn">ISBN</InputLabel>
            <Input
              disabled={!!content.livroReferencia || isReadOnly}
              fullWidth
              required={'required'}
              type="text"
              inputComponent={IsbnField}
              onChange={e => {
                handleChangeContent({ ...content, isbn: e.target.value })
              }}
              value={content.isbn || ''}
              id="field-isbn"
            />
            {!((contentFormErrors.fields || {})['isbn'] || {}).valid && formTouched ? (
              <Typography className={classes.errorMessage} noWrap color={'error'}>
                {((contentFormErrors.fields || {})['isbn'] || {}).errorMessage}
              </Typography>
            ) : null}
          </FormControl>
          <FormControl
            error={!((contentFormErrors.fields || {})['codigoProtheus'] || {}).valid && formTouched}
            className={classes.formControl}
            fullWidth
          >
            <InputLabel htmlFor="field-codigoProtheus">Código Protheus</InputLabel>
            <Input
              disabled={!!content.livroReferencia || isReadOnly}
              fullWidth
              required={'required'}
              inputComponent={IsbnField}
              type="text"
              onChange={e => {
                handleChangeContent({ ...content, codigoProtheus: e.target.value })
              }}
              value={content.codigoProtheus || ''}
              id="field-codigoProtheus"
            />
            {!((contentFormErrors.fields || {})['codigoProtheus'] || {}).valid && formTouched ? (
              <Typography className={classes.errorMessage} noWrap color={'error'}>
                {((contentFormErrors.fields || {})['codigoProtheus'] || {}).errorMessage}
              </Typography>
            ) : null}
          </FormControl>
          <FormControl
            error={!((contentFormErrors.fields || {})['copyrightLivro'] || {}).valid && formTouched}
            className={classes.formControl}
            fullWidth
          >
            <InputLabel htmlFor="field-copyrightLivro">Ano copyright</InputLabel>
            <Input
              disabled={!!content.livroReferencia || isReadOnly}
              fullWidth
              required={'required'}
              inputComponent={CopyrightField}
              onChange={e => {
                handleChangeContent({ ...content, copyrightLivro: e.target.value })
              }}
              value={content.copyrightLivro || ''}
              id="field-copyrightLivro"
            />
            {!((contentFormErrors.fields || {})['copyrightLivro'] || {}).valid && formTouched ? (
              <Typography className={classes.errorMessage} noWrap color={'error'}>
                {((contentFormErrors.fields || {})['copyrightLivro'] || {}).errorMessage}
              </Typography>
            ) : null}
          </FormControl>
          <FormControl
            error={!((contentFormErrors.fields || {})['edicaoLivro'] || {}).valid && formTouched}
            className={classes.formControl}
            fullWidth
          >
            <InputLabel htmlFor="field-edicaoLivro">Edição</InputLabel>
            <Input
              disabled={!!content.livroReferencia || isReadOnly}
              fullWidth
              required={'required'}
              type="text"
              inputComponent={EdicaoField}
              onChange={e => {
                handleChangeContent({ ...content, edicaoLivro: e.target.value })
              }}
              value={content.edicaoLivro || ''}
              id="field-edicaoLivro"
            />
            {!((contentFormErrors.fields || {})['edicaoLivro'] || {}).valid && formTouched ? (
              <Typography className={classes.errorMessage} noWrap color={'error'}>
                {((contentFormErrors.fields || {})['edicaoLivro'] || {}).errorMessage}
              </Typography>
            ) : null}
          </FormControl>
          <div className={classes.formControl}>
            <TextField
              disabled={!!content.livroReferencia || isReadOnly}
              fullWidth
              onChange={obj => {
                handleChangeContent({ ...content, especialidadesLivro: obj })
              }}
              error={
                !((contentFormErrors.fields || {})['especialidadesLivro'] || {}).valid &&
                formTouched
              }
              value={formatContentSelectValue(content.especialidadesLivro || [])}
              placeholder="Selecione..."
              name="react-select-chip-especialidadesLivro"
              label="Especialidades livro"
              InputLabelProps={{
                shrink: true
              }}
              InputProps={{
                inputComponent: SelectWrapped,
                inputProps: {
                  multi: true,
                  filterOptions: filterOptionsFunction,
                  instanceId: 'react-select-chip-label',
                  id: 'react-select-chip-especialidadesLivro',
                  loadOptions: API.specialities.getSelectSpecialities,
                  disableDelete: !!content.livroReferencia || isReadOnly
                }
              }}
            />
            {!((contentFormErrors.fields || {})['especialidadesLivro'] || {}).valid &&
            formTouched ? (
              <Typography className={classes.errorMessage} noWrap color={'error'}>
                {((contentFormErrors.fields || {})['especialidadesLivro'] || {}).errorMessage}
              </Typography>
            ) : null}
          </div>
        </fieldset>
        <fieldset>
          <legend>Seção</legend>
          <FormControl
            error={!((contentFormErrors.fields || {})['tituloSecao'] || {}).valid && formTouched}
            className={classes.formControl}
            fullWidth
          >
            <InputLabel htmlFor="field-tituloSecao">Titulo seção</InputLabel>
            <Input
              disabled={isReadOnly}
              fullWidth
              type="text"
              onChange={e => {
                handleChangeContent({ ...content, tituloSecao: e.target.value })
              }}
              value={content.tituloSecao}
              id="field-tituloSecao"
            />
            {!((contentFormErrors.fields || {})['tituloSecao'] || {}).valid && formTouched ? (
              <Typography className={classes.errorMessage} noWrap color={'error'}>
                {((contentFormErrors.fields || {})['tituloSecao'] || {}).errorMessage}
              </Typography>
            ) : null}
          </FormControl>
          <div className={classes.formControl}>
            <TextField
              disabled={isReadOnly}
              fullWidth
              onChange={obj => {
                handleChangeContent({ ...content, autoresSecao: obj })
              }}
              error={!((contentFormErrors.fields || {})['autoresSecao'] || {}).valid && formTouched}
              value={formatContentSelectValue(content.autoresSecao || [])}
              placeholder="Selecione..."
              name="react-select-chip-autoresSecao"
              label="Autores seção"
              InputLabelProps={{
                shrink: true
              }}
              InputProps={{
                inputComponent: SelectWrapped,
                inputProps: {
                  multi: true,
                  filterOptions: filterOptionsFunction,
                  instanceId: 'react-select-chip-label',
                  id: 'react-select-chip-autoresSecao',
                  loadOptions: API.authors.getSelectAuthors,
                  disableDelete: isReadOnly
                }
              }}
            />
            {!((contentFormErrors.fields || {})['autoresSecao'] || {}).valid && formTouched ? (
              <Typography className={classes.errorMessage} noWrap color={'error'}>
                {((contentFormErrors.fields || {})['autoresSecao'] || {}).errorMessage}
              </Typography>
            ) : null}
          </div>

          <FormControl
            error={!((contentFormErrors.fields || {})['textoSecao'] || {}).valid && formTouched}
            className={classes.formControl}
            fullWidth
          >
            <InputLabel htmlFor="field-textoSecao">Sobre a seção</InputLabel>
            <Input
              disabled={isReadOnly}
              fullWidth
              multiline
              type="text"
              onChange={e => {
                handleChangeContent({ ...content, textoSecao: e.target.value })
              }}
              value={content.textoSecao}
              id="field-textoSecao"
            />
            {!((contentFormErrors.fields || {})['textoSecao'] || {}).valid && formTouched ? (
              <Typography className={classes.errorMessage} noWrap color={'error'}>
                {((contentFormErrors.fields || {})['textoSecao'] || {}).errorMessage}
              </Typography>
            ) : null}
          </FormControl>
        </fieldset>
        <EditDocumentModal content={content} handleChangeContent={handleChangeContent} />
      </Fragment>
    )
  }
}

const mapStateToProps = state => {
  return {
    content: state.content.content,
    contentFormErrors: state.content.contentFormErrors,
    formTouched: state.content.contentFormTouched,
    conteudoHtml: state.content.conteudoHtml,
    token: state.auth.token
  }
}
const mapDispatchToProps = dispatch => {
  return {
    handleChangeContent: content => {
      dispatch(contentActions.handleChangeContent(content))
    },
    handleChangeReference: (refType, reference) => {
      dispatch(contentActions.handleChangeReference({ refType, reference }))
    },
    setContentFormTouched: () => {
      return dispatch(contentActions.setContentFormTouched())
    },
    removeHtmlDocument: () => {
      return dispatch(contentActions.removeHtmlDocument())
    },
    getHtmlPreview: content => {
      return dispatch(contentActions.getHtmlPreview(content))
    },
    changeMessage: ({ message, anchorOrigin }) => {
      dispatch(messageActions.changeMessage({ message, anchorOrigin }))
    },
    openEditDocumentModal: () => {
      dispatch(contentActions.openEditDocumentModal())
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles, { withTheme: true })(Aula))



// WEBPACK FOOTER //
// ./src/containers/Content/ContentTypes/Capitulo.js